// ===============================================
// FIXED: FreeDeliveryPromotion.js - NaN Issue Resolved
// ===============================================

import React from 'react'
import { Box, Typography } from '@mui/material'

const FreeDeliveryPromotion = ({ cartData }) => {
  
  // FIXED: Robust cart total calculation with NaN handling
  const calculateCartTotal = () => {
    // Check if cartData exists and has items
    if (!cartData || typeof cartData !== 'object' || Object.keys(cartData).length === 0) {
      return 0
    }
    
    let total = 0
    
    Object.values(cartData).forEach(item => {
     
      if (item && typeof item === 'object') {
        // Ensure price and count are valid numbers
        const price = Number(item.price) || 0
        const count = Number(item.count) || 0
        
        // Add to total only if both are valid numbers
        if (!isNaN(price) && !isNaN(count)) {
          total += (price * count)
        }
      }
    })
    return isNaN(total) ? 0 : Math.round(total)
  }

  const cartTotal = calculateCartTotal()
  const FREE_DELIVERY_THRESHOLD = 999
  const remainingAmount = FREE_DELIVERY_THRESHOLD - cartTotal

  // Don't show if cart is empty or cartTotal is invalid
  if (!cartData || Object.keys(cartData).length === 0 || cartTotal <= 0) {
    return null
  }

  // Don't show if already eligible for free delivery
  if (cartTotal >= FREE_DELIVERY_THRESHOLD) {
    return (
      <Box sx={{
        margin: '15px 0',
        padding: '12px',
        backgroundColor: '#FFF0DB',
        border: '2px solid #a4243d',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <Typography sx={{
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#a4243d'
        }}>
          🎉 Congratulations! You got FREE delivery!
        </Typography>
      </Box>
    )
  }

  // FIXED: Ensure remainingAmount is valid before displaying
  if (isNaN(remainingAmount) || remainingAmount <= 0) {
    return null
  }

  // Show promotion message - COMPACT VERSION
  return (
    <Box sx={{
      margin: '10px 0',
      padding: '8px 12px', // Reduced padding
      backgroundColor: '#FFF0DB',
      border: '2px solid #a4243d',
      borderRadius: '8px',
      textAlign: 'center'
    }}>
      {/* Line 1: Main message with amount */}
      <Typography sx={{
        fontSize: '14px',
        color: '#2c2c2c',
        marginBottom: '2px'
      }}>
        Add products worth <span style={{ fontWeight: 'bold', color: '#a4243d', fontSize: '16px' }}>₹{remainingAmount}</span> more to get <span style={{ fontWeight: 'bold', color: '#a4243d' }}>FREE delivery!</span>
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
        {/* Progress bar with circular indicator */}
        <Box sx={{
          flex: 1,
          height: '4px',
          backgroundColor: '#e0e0e0', // Gray track (remaining/incomplete)
          borderRadius: '2px',
          overflow: 'visible',
          position: 'relative'
        }}>
          {/* Red progress fill (completed portion) */}
          <Box sx={{
            height: '100%',
            width: `${Math.min(Math.max((cartTotal / FREE_DELIVERY_THRESHOLD) * 100, 0), 100)}%`,
            backgroundColor: '#a4243d', // Red fill for completed progress
            borderRadius: '2px',
            transition: 'width 0.3s ease'
          }} />
          
          {/* Circular progress indicator */}
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: `${Math.min(Math.max((cartTotal / FREE_DELIVERY_THRESHOLD) * 100, 0), 100)}%`,
            transform: 'translate(-50%, -50%)',
            width: '12px',
            height: '12px',
            backgroundColor: '#a4243d', // Red circle
            borderRadius: '50%',
            border: '2px solid white',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
            transition: 'left 0.3s ease'
          }} />
        </Box>
        
        {/* Current order info */}
        <Typography sx={{
          fontSize: '9px',
          color: '#666',
          whiteSpace: 'nowrap'
        }}>
          ₹{cartTotal} / ₹{FREE_DELIVERY_THRESHOLD}
        </Typography>
      </Box>
    </Box>
  )
}

export default FreeDeliveryPromotion